import "./InternalStack_module.css";
const InternalStack_module = {
    stack: "stack__aede1b2e99b6d6a3",
    recursive: "recursive__aede1b2e99b6d6a3"
};
export { InternalStack_module as default };
